import { useSupportLinks } from "@src/appV2/support/hooks/useSupportLinks";

import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

export function InHomeCommsBannerFooter() {
  const { inHomeFaqSupportLink } = useSupportLinks();
  return (
    <DialogFooter orientation="vertical">
      <Button fullWidth href={inHomeFaqSupportLink}>
        FAQ
      </Button>
    </DialogFooter>
  );
}
